import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { servicingSeatmapBackupReducer } from './servicing-seatmap-backup.reducer';
import { SERVICING_SEATMAP_BACKUP_STORE_NAME, ServicingSeatmapBackupState } from './servicing-seatmap-backup.state';

/** Token of the ServicingSeatmapBackup reducer */
export const SERVICING_SEATMAP_BACKUP_REDUCER_TOKEN = new InjectionToken<
  ActionReducer<ServicingSeatmapBackupState, Action>
>('Feature ServicingSeatmapBackup Reducer');

/** Provide default reducer for ServicingSeatmapBackup store */
export function getDefaultServicingSeatmapBackupReducer() {
  return servicingSeatmapBackupReducer;
}

@NgModule({
  imports: [StoreModule.forFeature(SERVICING_SEATMAP_BACKUP_STORE_NAME, SERVICING_SEATMAP_BACKUP_REDUCER_TOKEN)],
  providers: [{ provide: SERVICING_SEATMAP_BACKUP_REDUCER_TOKEN, useFactory: getDefaultServicingSeatmapBackupReducer }],
})
export class ServicingSeatmapBackupStoreModule {
  public static forRoot<T extends ServicingSeatmapBackupState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<ServicingSeatmapBackupStoreModule> {
    return {
      ngModule: ServicingSeatmapBackupStoreModule,
      providers: [{ provide: SERVICING_SEATMAP_BACKUP_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}